import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../../components/tables/MainTable";
import endpoints from "../../../services/endpoints";
import { TableDetailsItem } from "../../../components/tables/tableFunctions";
import useTranslation from "../../../components/CustomHooks/useTranslation";
import { adminContents } from "../../AdminManagement/components/AdminManagementContent";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { showToast } from "../../../components/toastMessage/toastSlice";
import { useDispatch } from "react-redux";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import GridTable from "../../../components/GridTable/GridTable";

export default function ListOfServiceFeeTransaction() {
  const navigation = useNavigate();
  const { serviceFeeTransaction } = endpoints;
  const { id } = useParams();
  const { translate } = useTranslation(adminContents);
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const { entireResponse } = useSelector((state: RootState) => state.list);
  const dispatch = useDispatch();
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Service Fee Received Date": {
      id: "service_fee_received_date",
    },
    "Service Fee Processed Date": {
      id: "service_fee_processed_date",
      custom: ["created_at"],
    },
    "Reference": {
      id: "reference",
      className: "min-w-[232px]",
    },
    "Note": {
      id: "note",
      className: "min-w-[302px]",
    },
    "Credit to": {
      id: "credit_to",
    },
    "Service Fee Type": {
      id: "service_fee_type",
    },
    "Service Fee Recieved Amount": {
      id: "service_fee_received_amount",
      custom: ["service_fee_received_amount"],
    },
    "Service Fee Paid Amount": {
      id: "service_fee_paid_amount",
      custom: ["service_fee_paid_amount"],
    },
  };
  const handleActions = async () => {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}`);
  }
  const addButtonClick = () => {
    if (entireResponse?.etopup_enabled || entireResponse?.bundle_activation_enabled) {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement/add-on-target`);
    } else {
      dispatch(showToast(
        {
          message: "Targets for eTop up and bundle activation already exists in Running / Not Started state, so new targets cannot be added at the moment.",
          type: "error",
        }
      ));
    }

  };
  const staticText = {
    emptyScreenText: {
      heading1: translate("There are no Service Fee Transaction's added yet"),
      heading2: translate("Click “Add Service Fee” to create one"),
    },
  };
  const dynamicFilterConfig: DynamicFilterConfig = {
    "Service Fee Processed Date": {
      label: "Service Fee Processed Date",
      type: "date",
      required: false,
      searchKey: {
        start: "processed_start_date",
        end: "processed_end_date",
      },
    },
    "Service Fee Received Date": {
      label: "Service Fee Received Date",
      type: "date",
      required: false,
      searchKey: {
        start: "received_start_date",
        end: "received_end_date",
      },
    },
  };
  return (
    <div>
      <Breadcrumbs
        navPath={["MNO Management", "List of MNO’s", "View Details", "List of Service Fee Transaction"]}
        heading="List of Service Fee Transaction"
        noNavigation
        links={[pathname ? pathname : "/mno-management/list-of-mnos", pathname ? pathname : "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`]}
      />
      <GridTable 
        staticText={staticText}
        mainEndPoint={`${serviceFeeTransaction}${id}`}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        searchPlaceholder={"Search by Transaction ID"}
        filters={true}
        exporting={true}
        noSearch={false}
        dynamicFilterConfig={dynamicFilterConfig}
        notfoundRoute={{ state: { route: '/mno-management/list-of-mnos' } }}
      />
    </div>
  );
}
